import { types } from "mobx-state-tree";

import { createCustomReadonlyDictionary } from "stores/templates/ReadonlyDictionaryStore";
import api from "services/api";
import { MSURL } from "utils/ms";
import { PUBLISH_STATUSES } from "constants/models";

const pathHealthCondition = "/nutrition/api/v1";
export const HealthConditionDictionaryItem = types.model({
  id: types.number,
  title: types.string,
});

const HealthConditionDictionary = createCustomReadonlyDictionary({
  itemModel: HealthConditionDictionaryItem,
  fetch: async function() {
    const response = await api.get(
      `${pathHealthCondition}/health-condition`,
      { publishStatus: PUBLISH_STATUSES.PUBLISHED },
      undefined,
      MSURL,
    );
    return { items: response.items };
  },
  getValue: value => value,
  getLabel: ({ title }) => title,
});

export default HealthConditionDictionary.create();
